import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Module from "@/models/lms/Module";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default class Group extends GenexLMSModel {
    static entity = 'groups'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
        }
    }

    /**
     * Returns all groups for the user
     * @function
     * @param {Object} pagination
     * @param {number} pagination.page - Which page to retrieve
     * @param {number} pagination.limit - How many entities to retrieve
     * @param {?Object} [query={}] - Query terms for the request
     * @param {?string} [query.modules]
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchAll({page = 1, limit = 15}, query = {}, relationships = []) {
        return this.api().get(`/groups`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        page: page, limit: limit, with: relationships
                    }, ...(query !== {} ? query : {}),
                },
                dataTransformer: ({data: {data}}) => {
                    return data.map(group => {
                        return {...group, ...group.attributes}
                    })
                },
            }
        )
    }
}
